// The pair page's USD price is not "canon TON × platform TON/USD".
//
// Measured on the operator's open positions, 2026-08-16: SFAILURE / the dusty
// GUTYA / GroypUtya / EAGLE all had the SAME price_ton on /portfolio and on
// /v1/pairs/:master. GRAM PnL was therefore ~0. USD was not: pair.price_usd
// uses the trade's own TON/USD rate, canon restates both sides at the current
// platform rate. He opened the pair, switched to USD, saw +0.34%, came back,
// and the portfolio then matched — because usePairFeed publishes the pair
// spot into the store. Without that visit the portfolio stayed on the
// restated zero.
//
// So every OPEN holding asks the same endpoint the pair page does, and
// publishes the same two numbers. The store already decides freshness.

import { fetchPairDetail } from '../api/pairs'
import type { PairDetail } from '../api/types'
import { type LivePriceInput, publishLivePrice } from './livePriceStore'

export function pairSpotInput(
  pair: Pick<PairDetail, 'price_ton' | 'price_usd' | 'price_source_ts'>
): LivePriceInput | null {
  const priceTon = pair.price_ton
  if (typeof priceTon !== 'number' || !Number.isFinite(priceTon) || priceTon <= 0) return null
  const rawUsd = pair.price_usd
  const priceUsd =
    typeof rawUsd === 'number' && Number.isFinite(rawUsd) && rawUsd > 0 ? rawUsd : null
  const ts = pair.price_source_ts
  return {
    priceTon,
    priceUsd,
    chainAt: typeof ts === 'number' && Number.isFinite(ts) ? ts : null,
  }
}

/** Open masters in a stable order. A portfolio refetch rebuilds the holdings
    array; this key must not, or the pair-spot effect restarts and drops 67. */
export function openHoldingMasters(
  holdings: ReadonlyArray<{ token_master: string; balance?: string }> | undefined
): string[] {
  const tokens = (holdings ?? [])
    .filter((holding) => {
      const balance = Number(holding.balance)
      return Number.isFinite(balance) && balance > 0
    })
    .map((holding) => holding.token_master)
  tokens.sort()
  return tokens
}

export async function publishHoldingPairSpots(
  tokens: readonly string[],
  fetchPair: (
    token: string
  ) => Promise<Pick<PairDetail, 'price_ton' | 'price_usd' | 'price_source_ts'>> = fetchPairDetail,
  publish: (token: string, input: LivePriceInput) => void = publishLivePrice
): Promise<void> {
  await Promise.all(
    tokens.map(async (token) => {
      try {
        const pair = await fetchPair(token)
        const input = pairSpotInput(pair)
        if (input) publish(token, input)
      } catch {
        // A missing pair must not take the other holdings' spots with it.
      }
    })
  )
}
